import type { LucideIcon } from 'lucide-react';
import {
  Cloud,
  Cpu,
  LayoutDashboard,
  LayoutGrid,
  Plug,
  Radio,
  Shield,
  Smartphone,
} from 'lucide-react';

export const platformOverviewPath = '/platform';

export const platformNavIcons: Record<string, LucideIcon> = {
  '/platform/iot-cloud': Cloud,
  '/platform/firmware-sdk': Cpu,
  '/platform/dashboard': LayoutDashboard,
  '/platform/mobile-apps': Smartphone,
  '/platform/apis-integrations': Plug,
  '/platform/security': Shield,
  '/platform/device-management': Radio,
  [platformOverviewPath]: LayoutGrid,
};

export interface PlatformNavItem {
  label: string;
  description: string;
  to: string;
}

export const platformNavItems: PlatformNavItem[] = [
  {
    label: 'IoT Cloud',
    description: 'Backend & MQTT infrastructure',
    to: '/platform/iot-cloud',
  },
  {
    label: 'Firmware SDK',
    description: 'Embedded platform',
    to: '/platform/firmware-sdk',
  },
  {
    label: 'Dashboard',
    description: 'Admin & analytics',
    to: '/platform/dashboard',
  },
  {
    label: 'Mobile Apps',
    description: 'White-label apps',
    to: '/platform/mobile-apps',
  },
  {
    label: 'APIs & Integrations',
    description: 'Developer ecosystem',
    to: '/platform/apis-integrations',
  },
  {
    label: 'Security',
    description: 'Enterprise-grade security',
    to: '/platform/security',
  },
  {
    label: 'Device Management',
    description: 'OTA & provisioning',
    to: '/platform/device-management',
  },
];

export interface PlatformMegaMenuLink {
  label: string;
  to: string;
  description?: string;
  badge?: 'API';
}

const platformNavDescriptions = Object.fromEntries(
  platformNavItems.map((item) => [item.to, item.description]),
) as Record<string, string>;

function withDescriptions(
  links: Omit<PlatformMegaMenuLink, 'description'>[],
): PlatformMegaMenuLink[] {
  return links.map((link) => ({
    ...link,
    description:
      platformNavDescriptions[link.to] ??
      (link.to === platformOverviewPath ? 'Full stack at a glance' : undefined),
  }));
}

export const platformMegaMenuLinks: PlatformMegaMenuLink[] = withDescriptions([
  { label: 'IoT Cloud', to: '/platform/iot-cloud' },
  { label: 'Device Management', to: '/platform/device-management' },
  { label: 'Firmware SDK', to: '/platform/firmware-sdk' },
  { label: 'Mobile Apps', to: '/platform/mobile-apps' },
  { label: 'Platform Overview', to: platformOverviewPath },
  { label: 'Dashboard', to: '/platform/dashboard' },
  { label: 'APIs & Integrations', to: '/platform/apis-integrations', badge: 'API' },
  { label: 'Security', to: '/platform/security' },
]);
